import { render, staticRenderFns } from "./LvSplitInput.vue?vue&type=template&id=6a877ba2"
import script from "./LvSplitInput.vue?vue&type=script&lang=js"
export * from "./LvSplitInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports